import React from "react";

export default function PoznamkaKarta({
  poznamka,
  setPoznamka,
  className = "",
}) {
  return (
    <div className={`card-section ${className}`.trim()}>
      <h2>Poznámky:</h2>

      <div className="form">
        <textarea
          className="form_textarea"
          value={poznamka}
          onChange={(e) => setPoznamka(e.target.value)}
          placeholder="..."
        />
      </div>
    </div>
  );
}